import React, {Component} from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import _ from 'lodash'

import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import {WINDOW, DOCUMENT, IS_MOBILE} from '../../constants/environment'
import AccessoryBodyTypeTabName from "../accessory-body-type-tab-name";
import Cta from "../cta";
import BodyControl from "../../components/body";
import './styles.css';

import ScrollLoader from '../../components/scroll-loader';

// 「すべて」カテゴリのデフォルト写真枚数
const ACCESSORIES_COEFFICIENT = 16;

/**
 *  AccessoryList
 */
class AccessoryList extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    bodyTypeNames: PropTypes.array,
    color: PropTypes.string,
    accessories: PropTypes.arrayOf(PropTypes.shape({
      accessoryId: PropTypes.string,
      category: PropTypes.string,
      subCategory: PropTypes.string,
      title: PropTypes.string,
      price: PropTypes.number,
      images: PropTypes.array,
      modelName: PropTypes.string,
      bodyTypeModel: PropTypes.string,
      href: PropTypes.string
    })),
    isCountable: PropTypes.bool,
    everySixteenAccessories: PropTypes.array
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    bodyTypeNames: null,
    color: null,
    accessories: null
  };
  
  constructor(props) {
    super();
    this.props = props;

    this.state = {
      bodyTypeName: '',
      category: '',
      subCategory: '',
      accessories: [],
      // 「さらに表示する」押下時の表示用
      everySixteenAccessories: [],
      // 「さらに表示する」押下回数キャッシュ用
      counterClickedTime: 1,
      isOpenSubCategory: false
    };

    this.tmp = {
      bodyTypeName: '',
      category: '',
      subCategory: '',
      accessories: []
    };

    this.showItemNum  = 4;

    this.categoryIntervalId;

  }

  componentDidMount() {

    setTimeout(this.setDefaultState, 100);

    this.showItemNum = IS_MOBILE ? 2 : 4;

    // this.applyFilter();
    setTimeout(this.applyFilter, 200);

    if(IS_MOBILE){
      setTimeout(() => {
        this.slideCategory(true);
      }, 300);
    }
  };

  setDefaultState = () => {
    //URLパラメータのcar_idから初期状態を設定
    // let query_car_id = this.getQuery('car_id');

    // if(query_car_id !== false){
    //   let isExist = false;
    //   //表示タブ名の中に存在するかどうか
    //   if(this.props.bodyTypeNames && Array.isArray(this.props.bodyTypeNames) && this.props.bodyTypeNames.length > 0){
    //     for(let i = 0; i < this.props.bodyTypeNames.length; i++){
    //       let _bodyTypeName = this.props.bodyTypeNames[i].props.bodyTypeName;
    //       if(_bodyTypeName === query_car_id){
    //         isExist = true;
    //         break;
    //       }
    //     }
    //   }
    //   //存在しなかった場合は、無効なcar_idが参照されたとして、上書きして無効とする
    //   if(!isExist){
    //     query_car_id = false;
    //   }
    // }

    // if(query_car_id !== false){
    //   this.tmp.bodyTypeName = query_car_id;
    //   this.tmp.category = '';
    //   this.tmp.subCategory = '';
    //   this.setState({
    //     bodyTypeName: query_car_id,
    //     category: '',
    //     subCategory: ''
    //   });
    //   return;
    // }

    //////////////////////////////////////////////////////////////////////////////////////////

    //cookieに前回保存した状態から初期状態を設定
    let bodyTypeName = this.getCookie('mj_acbt');
    let category = this.getCookie('mj_accg');
    let subCategory = this.getCookie('mj_acscg');

    console.log('before', bodyTypeName, category, subCategory);

    //他の車種でセットされたbodyTypeNameのクッキー値（mj_acbt）は反映されないようにする
    if(bodyTypeName !== false && bodyTypeName !== ''){
      let isExist = false;
      //表示タブ名の中に存在するかどうか
      if(this.props.bodyTypeNames && Array.isArray(this.props.bodyTypeNames) && this.props.bodyTypeNames.length > 0){
        for(let i = 0; i < this.props.bodyTypeNames.length; i++){
          let _bodyTypeName = this.props.bodyTypeNames[i].props.bodyTypeName;
          if(_bodyTypeName === bodyTypeName){
            isExist = true;
            break;
          }
        }
      }
      //存在しなかった場合は、他の車種でセットされたbodyTypeNameが参照されたとして、上書きして無効とする
      if(!isExist){
        // const firstBodyTypeName = this.refs.form.querySelector('input[name="bodyTypeName"]');
        // let value = firstBodyTypeName && firstBodyTypeName.value && firstBodyTypeName.value !== '' ? firstBodyTypeName.value : '';
        // bodyTypeName = value;
        if(this.props.bodyTypeNames && Array.isArray(this.props.bodyTypeNames) && this.props.bodyTypeNames.length > 0){
          bodyTypeName = this.props.bodyTypeNames[0].props.bodyTypeName;
          category = false;
          subCategory = false;
        }
        else{
          bodyTypeName = false;
          category = false;
          subCategory = false;
        }

        DOCUMENT.cookie = "mj_accopen=;path=/;max-age=0;secure;samesite=lax";
      }
    }

    //存在しないcategoryのクッキー値（mj_accg）は無効とする
    if(category !== false && category !== ''){
      let isExist = false;
      //表示タブ名の中に存在するかどうか
      if(this.props.accessories && Array.isArray(this.props.accessories) && this.props.accessories.length > 0){
        for(let i = 0; i < this.props.accessories.length; i++){
          let _category = this.props.accessories[i].category;
          if(_category === category){
            isExist = true;
            break;
          }
        }
      }
      //存在しなかった場合は、上書きして無効とする
      if(!isExist){
        category = false;
        subCategory = false;
      }

    }

    //存在しないsubCategoryのクッキー値（mj_acscg）は無効とする
    if(subCategory !== false && subCategory !== ''){
      let isExist = false;
      //表示タブ名の中に存在するかどうか
      if(this.props.accessories && Array.isArray(this.props.accessories) && this.props.accessories.length > 0){
        for(let i = 0; i < this.props.accessories.length; i++){
          let _subCategory = this.props.accessories[i].subCategory;
          if(_subCategory === subCategory){
            isExist = true;
            break;
          }
        }
      }
      //存在しなかった場合は、上書きして無効とする
      if(!isExist){
        subCategory = false;
      }
    }


    if(bodyTypeName !== false){
      this.tmp.bodyTypeName = bodyTypeName;
      this.setState({
        bodyTypeName: bodyTypeName
      });
    }
    if(category !== false){
      this.tmp.category = category;
      this.setState({
        category: category
      });
    }
    if(subCategory !== false){
      this.tmp.subCategory = subCategory;
      this.setState({
        subCategory: subCategory
      });
    }
    console.log('after', bodyTypeName, category, subCategory);
    if(bodyTypeName !== false || category !== false || subCategory !== false){
      return;
    }

    //////////////////////////////////////////////////////////////////////////////////////////

    //cookieに保存されたcar_idから初期状態を設定
    // let cookie_car_id = this.getCookie('mjcarid');

    // if(cookie_car_id !== false){
    //   let isExist = false;
    //   //表示タブ名の中に存在するかどうか
    //   if(this.props.bodyTypeNames && Array.isArray(this.props.bodyTypeNames) && this.props.bodyTypeNames.length > 0){
    //     for(let i = 0; i < this.props.bodyTypeNames.length; i++){
    //       let _bodyTypeName = this.props.bodyTypeNames[i].props.bodyTypeName;
    //       if(_bodyTypeName === cookie_car_id){
    //         isExist = true;
    //         break;
    //       }
    //     }
    //   }
    //   //存在しなかった場合は、無効なcar_idが参照されたとして、上書きして無効とする
    //   if(!isExist){
    //     cookie_car_id = false;
    //   }
    // }

    // if(cookie_car_id !== false){
    //   this.tmp.bodyTypeName = cookie_car_id;
    //   this.tmp.category = '';
    //   this.tmp.subCategory = '';
    //   this.setState({
    //     bodyTypeName: cookie_car_id,
    //     category: '',
    //     subCategory: ''
    //   });
    //   return;
    // }

    //////////////////////////////////////////////////////////////////////////////////////////

    //デフォルト値から初期状態を設定
    if(this.refs.form){
      const firstBodyTypeName = this.refs.form.querySelector('input[name="bodyTypeName"]');
      if(firstBodyTypeName){
        let value = firstBodyTypeName.value;
        this.tmp.bodyTypeName = value;
        this.tmp.category = '';
        this.tmp.subCategory = '';
        this.setState({
          bodyTypeName: value,
          category: '',
          subCategory: ''
        });
      }
    }
  };

  getCookie = (key) => {
    if(!DOCUMENT || !DOCUMENT.cookie){
      return false;
    }
    let cookies = document.cookie.split(';');
    for(let i = 0; i < cookies.length; i++){
      let cookie = cookies[i].split('=');
      if(cookie[0].trim() === key){
        return unescape(cookie[1].trim());
      }
    }

    return false;
  };

  getQuery = (key) => {
    if(!WINDOW || !WINDOW.location){
      return false;
    }
    let params = WINDOW.location.search.substring(1).split('&');
    for(let i = 0; i < params.length; i++){
      let param = params[i].split('=');
      if(param[0].trim() === key){
        return param[1].trim();
      }
    }
    return false;
  };
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      bodyTypeNames,
      color,
      accessories,
      isCountable,
      everySixteenAccessories
    } = this.props;

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <ScrollLoader>
          <div className='AccessoryList' ref='self'>
            <div className={'AccessoryList__container' + (color && color !== '' ? ' AccessoryList__container--' + color : null)}>
              <form className='AccessoryList__container__form' ref="form" onChange={this.onChangeForm}>
                {(() => {
                  if(bodyTypeNames && Array.isArray(bodyTypeNames) && bodyTypeNames.length > 0){
                    return(
                      <div className='AccessoryList__container__form__bodyTypeName'>
                        <ul className='AccessoryList__container__form__bodyTypeName__list'>
                          {
                            bodyTypeNames.map((item, index) => {
                              let props = item.props;
                              return(
                                <li className="AccessoryList__container__form__bodyTypeName__list__item" key={index}>
                                  <Wrapper
                                    containerId={props.containerId}
                                    containerClass={props.containerClass}
                                    anchorPoint={props.anchorPoint}
                                    anchorName={props.anchorName}
                                  >
                                    <label className="AccessoryList__container__form__bodyTypeName__list__item__label">
                                      <input className="AccessoryList__container__form__bodyTypeName__list__item__label__radio" type="radio" name="bodyTypeName" value={props.bodyTypeName} checked={this.state.bodyTypeName === props.bodyTypeName} onChange={this.onChangeBodyTypeName} />
                                      <span className="AccessoryList__container__form__bodyTypeName__list__item__label__text">{props.bodyTypeTabName}</span>
                                    </label>
                                  </Wrapper>
                                </li>
                              )
                            })
                          }
                        </ul>
                      </div>
                    )
                  }
                })()}
                <div
                  className='AccessoryList__container__form__category'
                  ref='category'
                  onTransitionEnd={(e)=> {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  }}
                >
                  <ul className='AccessoryList__container__form__category__list'>
                    {(() => {
                      let categories = this.getCategories(this.props.accessories);
                      return(
                        categories.map((category, index) => {
                          return(
                            <li className="AccessoryList__container__form__category__list__item" key={index}>
                              <label className="AccessoryList__container__form__category__list__item__label">
                                <input className="AccessoryList__container__form__category__list__item__label__radio" type="radio" name="category" value={category.value} checked={this.tmp.category === category.value} onChange={this.onChangeCategory} />
                                <span className="AccessoryList__container__form__category__list__item__label__text">{category.label}</span>
                              </label>
                            </li>
                          )
                        })
                      )
                    })()}
                  </ul>
                </div>
                <div
                  className={
                    'AccessoryList__container__form__subCategory' +
                    (this.state.category === '' ? ' hide' : '') +
                    (this.state.isOpenSubCategory ? ' open': '')
                  }
                  ref='subCategory'
                  onTransitionEnd={(e)=> {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  }}
                >
                  <div className='AccessoryList__container__form__subCategory__title'>
                    <a href='javascript:void(0)' className='AccessoryList__container__form__subCategory__title__link' onClick={this.onClickPulldown}>
                      {this.state.subCategory === '' ? 'さらに絞り込む' : this.state.subCategory}
                    </a>
                  </div>
                  <div className='AccessoryList__container__form__subCategory__pulldown'>
                    <div className='AccessoryList__container__form__subCategory__pulldown__container'>
                      <ul className='AccessoryList__container__form__subCategory__pulldown__list' ref='pulldownList'>
                        {(() => {
                          let subCategories = this.getSubCategories(this.props.accessories);
                          return(
                            subCategories.map((subCategory, index) => {
                              return(
                                <li className="AccessoryList__container__form__subCategory__pulldown__list__item" key={index}>
                                  <label className="AccessoryList__container__form__subCategory__pulldown__list__item__label">
                                    <input className="AccessoryList__container__form__subCategory__pulldown__list__item__label__radio" type="radio" name="subCategory" value={subCategory.value} checked={this.tmp.subCategory === subCategory.value} onChange={this.onChangeSubCategory} />
                                    <span className="AccessoryList__container__form__subCategory__pulldown__list__item__label__text">{subCategory.label}</span>
                                  </label>
                                </li>
                              )
                            })
                          )
                        })()}
                      </ul>
                    </div>
                    <a href='javascript:void(0)' className='AccessoryList__container__form__subCategory__pulldown__close' onClick={this.onClickPulldownClose}>CLOSE</a>
                  </div>
                </div>
              </form>
              <div
                className='AccessoryList__container__accessories'
                ref='accessories'
                onTransitionEnd={(e)=> {
                  e.currentTarget.classList.remove('fadein');
                  e.currentTarget.style.opacity = "";
                }}
              >
                {(() => {
                  // category: すべて
                  if(this.state.category === ''){
                    let showCount;
                    if(DOCUMENT){
                      showCount = this.getCookie('mj_accopen');
                      showCount = showCount !== false ? parseInt(showCount) : 16;
                    }
                    return (
                      <div className={'AccessoryList__container__accessories__category'}>
                        <ul className={'AccessoryList__container__accessories__category__list'}>
                          {
                            (everySixteenAccessories && everySixteenAccessories.length > 0) &&
                              (everySixteenAccessories.map((accessory, index) =>
                                (
                                  <li
                                    className={'AccessoryList__container__accessories__category__list__item' + (index < showCount ? ' show' : '')}
                                    key={index}
                                  >
                                    <a
                                      href={`${accessory.href}${accessory.accessoryId}`}
                                      className="AccessoryList__container__accessories__category__list__item__link"
                                      onClick={this.onClickAccessoryLink}
                                    >
                                      <div className={'AccessoryList__container__accessories__category__list__item__link__content'}>
                                        {accessory.images && Array.isArray(accessory.images) && accessory.images[0] !== '' ?
                                          <div className={'AccessoryList__container__accessories__category__list__item__link__content__image__wrap'}>
                                            <img src={accessory.images[0]} className={'AccessoryList__container__accessories__category__list__item__link__content__image'} />
                                          </div>
                                        : null}
                                        {accessory.title && accessory.title !== '' ? <div className={'AccessoryList__container__accessories__category__list__item__link__content__title'}>{accessory.title}</div> : null}
                                        {accessory.price ? <div className={'AccessoryList__container__accessories__category__list__item__link__content__price'}>¥{Number(accessory.price).toLocaleString()}（消費税込）</div> : null}
                                      </div>
                                    </a>
                                  </li>
                                ))
                              )
                          }
                        </ul>
                        {
                          isCountable ?
                          (<Cta
                            {...{
                              ctaType: 'Free',
                              text: 'さらに表示する',
                              linkType: 'Button',
                              color: this.props.color || 'Light',
                              buttonStyle: 'Standard',
                              handleClick: this.onClickMore
                            }}
                          />) :
                          (<Cta
                            {...{
                              ctaType: 'Free',
                              text: '閉じる',
                              linkType: 'Button',
                              color: this.props.color || 'Light',
                              buttonStyle: 'Standard',
                              handleClick: this.onClickLess
                            }}
                          />)
                        }
                      </div>
                    )
                  }
                  // category: すべて以外
                  else{
                    let subCategories = this.getSubCategories(this.state.accessories);
                    return(
                      subCategories.map((subCategory, index) => {
                        if(subCategory.value === ''){
                          return false;
                        }
                        let accessories = this.getSubCategoriesAccessories(this.state.accessories, subCategory.value);
                        return(
                          <div className='AccessoryList__container__accessories__category' key={index}>
                            <div className='AccessoryList__container__accessories__category__title'>{subCategory.label}</div>
                            <ul className='AccessoryList__container__accessories__category__list'>
                              {
                                accessories.map((accessory, index) => {
                                  let href = accessory.href + accessory.accessoryId;
                                  return(
                                    <li
                                      className=
                                      {
                                        "AccessoryList__container__accessories__category__list__item" +
                                        " show"
                                        // (index < this.showItemNum || this.state.subCategory !== '' ? ' show' : '')
                                      }
                                      key={index}
                                    >
                                      <a
                                        href={href}
                                        className="AccessoryList__container__accessories__category__list__item__link"
                                        onClick={this.onClickAccessoryLink}
                                      >
                                        <div className='AccessoryList__container__accessories__category__list__item__link__content'>
                                          {accessory.images && Array.isArray(accessory.images) && accessory.images[0] !== '' ?
                                            <div className='AccessoryList__container__accessories__category__list__item__link__content__image__wrap'>
                                              <img src={accessory.images[0]} className='AccessoryList__container__accessories__category__list__item__link__content__image' />
                                            </div>
                                          : null}
                                          {accessory.title && accessory.title !== '' ? <div className='AccessoryList__container__accessories__category__list__item__link__content__title'>{accessory.title}</div> : null}
                                          {accessory.price ? <div className='AccessoryList__container__accessories__category__list__item__link__content__price'>¥{Number(accessory.price).toLocaleString()}（消費税込）</div> : null}
                                        </div>
                                      </a>
                                    </li>
                                  )
                                })
                              }
                            </ul>
                            {(() => {
                              // if(accessories.length > this.showItemNum && this.state.subCategory === ''){
                              //   return(
                              //     <React.Fragment>
                              //       <div className='AccessoryList__container__accessories__category__more show'>
                              //         <Cta
                              //           {...{
                              //             ctaType: 'Free',
                              //             text: 'すべて見る',
                              //             linkType: 'Button',
                              //             color: this.props.color || 'Light',
                              //             buttonStyle: 'Standard',
                              //             handleClick: this.onClickMore
                              //           }}
                              //         />
                              //       </div>
                              //       <div className='AccessoryList__container__accessories__category__less'>
                              //         <Cta
                              //           {...{
                              //             ctaType: 'Free',
                              //             text: '閉じる',
                              //             linkType: 'Button',
                              //             color: this.props.color || 'Light',
                              //             buttonStyle: 'Standard',
                              //             handleClick: this.onClickLess
                              //           }}
                              //         />
                              //       </div>
                              //     </React.Fragment>
                              //   )
                              // }
                            })()}
                          </div>
                        )
                      })
                    )
                  }
                })()}
              </div>
  
            </div>
          </div>
        </ScrollLoader>
      </Wrapper>
    )
  }

  onChangeForm = (e) => {

    // const form = this.refs.form;

    // this.tmp.bodyTypeName = form.bodyTypeName != null && form.bodyTypeName.value != null ? form.bodyTypeName.value : '';
    // this.tmp.category = form.category != null && form.category.value != null ? form.category.value : '';
    // this.tmp.subCategory = form.subCategory != null && form.subCategory.value != null ? form.subCategory.value : '';

    // this.applyFilter();
  };

  onChangeBodyTypeName = (e) => {
    this.tmp.bodyTypeName = e.target.value;
    this.tmp.category = '';
    this.tmp.subCategory = '';
    this.setState({
      bodyTypeName: this.tmp.bodyTypeName,
      category: this.tmp.category,
      subCategory: this.tmp.subCategory,
      isOpenSubCategory: false
    });

    setTimeout(() => {
      this.setMinHeight(false);
    }, 10);

    // cookie削除
    if(WINDOW && DOCUMENT){
      let pathname = WINDOW.location.pathname;
      // pathname = '/';
      DOCUMENT.cookie = "mj_accopen=;path=" + pathname + ";max-age=0;secure;samesite=lax";
    }

    this.applyFilter();
    
    //fadein
    this.refs.category.classList.remove('fadein');
    this.refs.subCategory.classList.remove('fadein');
    this.refs.accessories.classList.remove('fadein');
    this.refs.category.style.opacity = 0;
    this.refs.subCategory.style.opacity = 0;
    this.refs.accessories.style.opacity = 0;
    setTimeout(
      () => {
        this.refs.category.classList.add('fadein');
        this.refs.subCategory.classList.add('fadein');
        this.refs.accessories.classList.add('fadein');
        this.refs.category.style.opacity = 1;
        this.refs.subCategory.style.opacity = 1;
        this.refs.accessories.style.opacity = 1;
      },
    10);
    
    if(IS_MOBILE){
      const categoryList = this.refs.category.querySelector(".AccessoryList__container__form__category__list");
      categoryList.scrollLeft = 0;
      clearInterval(this.categoryIntervalId);
    }
  }

  onChangeCategory = (e) => {
    this.tmp.category = e.target.value;
    this.tmp.subCategory = '';
    this.setState({
      category: this.tmp.category,
      subCategory: this.tmp.subCategory,
      isOpenSubCategory: false
    });

    setTimeout(() => {
      this.setMinHeight(false);
    }, 10);

    // cookie削除
    if(WINDOW && DOCUMENT){
      let pathname = WINDOW.location.pathname;
      // pathname = '/';
      DOCUMENT.cookie = "mj_accopen=;path=" + pathname + ";max-age=0;secure;samesite=lax";
    }

    this.applyFilter();

    //fadein
    this.refs.subCategory.classList.remove('fadein');
    this.refs.accessories.classList.remove('fadein');
    this.refs.subCategory.style.opacity = 0;
    this.refs.accessories.style.opacity = 0;
    setTimeout(
      () => {
        this.refs.subCategory.classList.add('fadein');
        this.refs.accessories.classList.add('fadein');
        this.refs.subCategory.style.opacity = 1;
        this.refs.accessories.style.opacity = 1;
      },
    10);

    if(IS_MOBILE){
      this.slideCategory();
    }
  }

  slideCategory = (noTime=false) => {
    const checkedRadio = this.refs.category.querySelector("input[type='radio']:checked");
    const current = checkedRadio.parentNode.parentNode;
    const parent = current.parentNode;
    const currentRect = current.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    let children = parent.children;
    let child;
    let currentLeft = 0;
    let totalWidth = 0;
    for(let i = 0; i < parent.children.length; i++){
      child = parent.children[i];
      totalWidth += child.getBoundingClientRect().width;
    }
    for(let i = 0; i < parent.children.length; i++){
      child = parent.children[i];
      if(child === current){
        break;
      }
      currentLeft += child.getBoundingClientRect().width;
    }

    let scrollLeft = currentLeft - parentRect.width / 2 + currentRect.width / 2;
    scrollLeft = scrollLeft < 0 ? 0 : scrollLeft;

    if(totalWidth - scrollLeft < parentRect.width){
      scrollLeft = totalWidth - parentRect.width
    }
    
    scrollLeft = Math.floor(scrollLeft);

    //スライドアニメーションなしで処理したい場合
    if(noTime){
      parent.scrollLeft = scrollLeft;
      return;
    }

    clearInterval(this.categoryIntervalId);
    this.categoryIntervalId = setInterval(
      () => {
        if(scrollLeft - parent.scrollLeft < 0){
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * -0.1) * -1;
        }
        else{
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * 0.1);
        }
        
        if(Math.abs(scrollLeft - parent.scrollLeft) < 1){
          parent.scrollLeft = scrollLeft;
          clearInterval(this.categoryIntervalId);
        }
        // console.log(parent.scrollLeft, scrollLeft);
      },
    1000 / 60);
  }

  onChangeSubCategory = (e) => {
    this.tmp.subCategory = e.target.value;
    this.setState({
      subCategory: this.tmp.subCategory,
      isOpenSubCategory: false
    });
    this.applyFilter();

    setTimeout(() => {
      this.setMinHeight(false);
    }, 10);

    //fadein
    this.refs.accessories.classList.remove('fadein');
    this.refs.accessories.style.opacity = 0;
    setTimeout(
      () => {
        this.refs.accessories.classList.add('fadein');
        this.refs.accessories.style.opacity = 1;
      },
    10);
  }

  getCategories = (accessories) => {
    let arr = [];
    if(!accessories || !Array.isArray(accessories)){
      return arr;
    }
    accessories.map((accessory, index) => {
      if(this.tmp.bodyTypeName && this.tmp.bodyTypeName !== accessory.bodyTypeModel){
        return false;
      }
      arr.push({
        label: accessory.category,
        value: accessory.category
      });
    })
    if(arr.length > 0){
      arr.unshift({
        label: 'すべて',
        value: ''
      });
    }
    let cleanArr = arr.filter((v1,i1,a1) => {
      return (a1.findIndex((v2) => {
        return (v1.value===v2.value)
      }) === i1);
    });
    return cleanArr;
  };

  getSubCategories = (accessories) => {
    let arr = [];
    if(!accessories || !Array.isArray(accessories)){
      return arr;
    }
    accessories.map((accessory, index) => {
      if(this.tmp.bodyTypeName && this.tmp.bodyTypeName !== accessory.bodyTypeModel){
        return false;
      }
      else if(this.tmp.category !== '' && this.tmp.category !== accessory.category){
        return false;
      }
      arr.push({
        label: accessory.subCategory,
        value: accessory.subCategory
      });
    })
    if(arr.length > 0){
      arr.unshift({
        label: 'すべてのアクセサリ',
        value: ''
      });
    }
    let cleanArr = arr.filter((v1,i1,a1) => {
      return (a1.findIndex((v2) => {
        return (v1.value===v2.value)
      }) === i1);
    });
    return cleanArr;
  };

  getSubCategoriesAccessories = (accessories, subCategory) => {
    let arr = [];
    accessories.map((accessory, index) => {
      if(accessory.subCategory === subCategory){
        arr.push(accessory);
      }
    })
    return arr;
  };

  /**
   * 「さらに表示する」押下時に呼ばれる
   */
  onClickMore = (e) => {
    if (!this.props.isCountable) {
      return
    }

    // 「さらに表示する」押下回数算出用の係数
    const additionalNumber = 1
    // 「さらに表示する」押下回数
    const latestCountNumber = this.state.counterClickedTime + additionalNumber
    // 「さらに表示する」押下時の表示枚数 (16枚毎に乗算)
    const latestTotal = ACCESSORIES_COEFFICIENT * latestCountNumber

    // 「さらに表示する」押下時の表示アイテムを配列にする
    const mustDisplayAccessories =
      _.reduce(this.state.accessories, (accumulator, currentValue, index) => {
        if (index < this.state.accessories.length && index < latestTotal) {
          return [...accumulator, currentValue]
        }
        return [...accumulator]
      }, [])

    if (latestTotal > this.state.accessories.length) {
      this.props.updateCounterClickedTime({
        isCountable: false, everySixteenAccessories: mustDisplayAccessories
      })
    } else {
      this.props.updateCounterClickedTime({
        isCountable: true, everySixteenAccessories: mustDisplayAccessories
      })
    }

    let items = this.closest(e.currentTarget, '.AccessoryList__container__accessories__category').querySelectorAll('.AccessoryList__container__accessories__category__list__item');
    let appendCount = this.tmp.category === '' ? 16 : items.length;
    let showCount = 0;

    for(let i = 0; i < items.length; i++){
      if(!items[i].classList.contains('show') && appendCount > 0){
        items[i].classList.add('show')
        appendCount--;
      }
      if(items[i].classList.contains('show')){
        showCount++;
      }
    }

    if(items.length === showCount){
      let category = this.closest(e.currentTarget, '.AccessoryList__container__accessories__category');
      let more = category.querySelector('.AccessoryList__container__accessories__category__more');
      let less = category.querySelector('.AccessoryList__container__accessories__category__less');
      if(more){
        more.classList.remove('show');
      }
      if(less){
        less.classList.add('show');
      }
    }

    //「すべて」の際は表示個数を記録して、アクセサリ詳細から戻ったときに表示個数を再現する
    if(this.tmp.category === ''){
      // cookieに値をセット
      if(WINDOW && DOCUMENT){
        let pathname = WINDOW.location.pathname;
        // pathname = '/';
        DOCUMENT.cookie = "mj_accopen=" + showCount + ";path=" + pathname + ";secure;samesite=lax";
      }
    }

    // 「さらに表示する」押下回数をキャッシュしておく
    this.setState({ counterClickedTime: latestCountNumber })

    //
    this.triggerEvent(WINDOW, 'scroll');
  };

  onClickLess = (e) => {
    let items = this.closest(e.currentTarget, '.AccessoryList__container__accessories__category').querySelectorAll('.AccessoryList__container__accessories__category__list__item');
    let showCount;

    if(IS_MOBILE){
      showCount = this.tmp.category === '' ? 16 : 2;
    }
    else{
      showCount = this.tmp.category === '' ? 16 : 4;
    }

    for(let i = 0; i < items.length; i++){
      items[i].classList.remove('show');
      if(i < showCount){
        items[i].classList.add('show');
      }
    }

    let category = this.closest(e.currentTarget, '.AccessoryList__container__accessories__category');
    let more = category.querySelector('.AccessoryList__container__accessories__category__more');
    let less = category.querySelector('.AccessoryList__container__accessories__category__less');
    if(more){
      more.classList.add('show');
    }
    if(less){
      less.classList.remove('show');
    }

    //「すべて」の際は表示個数を記録して、アクセサリ詳細から戻ったときに表示個数を再現する
    if(this.tmp.category === ''){
      // cookieに値をセット
      if(WINDOW && DOCUMENT){
        let pathname = WINDOW.location.pathname;
        // pathname = '/';
        DOCUMENT.cookie = "mj_accopen=16;path=" + pathname + ";secure;samesite=lax";
      }
    }

    //上部へスクロール
    if(this.tmp.category === ''){
      BodyControl.scrollToNode(this.refs.self);
    }
    else{
      let selfCategory = this.closest(e.currentTarget, '.AccessoryList__container__accessories__category');
      BodyControl.scrollToNode(selfCategory);
    }
  };

  onClickPulldown = (e) => {
    const flg = !this.state.isOpenSubCategory;
    this.setState({
      isOpenSubCategory: flg
    });

    setTimeout(() => {
      this.setMinHeight(flg);
    }, 10);
    
  };

  onClickPulldownClose = (e) => {
    this.setState({
      isOpenSubCategory: false
    });
    setTimeout(() => {
      this.setMinHeight(false);
    }, 10);
  };

  //サブカテゴリまで選択時にブロック自体の高さがプルダウンよりも小さくなったときに、プルダウン開閉時に高さを調整する処理
  setMinHeight = (isOpen) => {
    let height = '';
    if(isOpen){
      const minHeight = this.refs.form.clientHeight + this.refs.pulldownList.clientHeight + 70;
      const selfHeight = this.refs.self.clientHeight;
      const accessoriesHeight = this.refs.accessories.clientHeight;
      if(minHeight > selfHeight){
        height = (accessoriesHeight + (minHeight - selfHeight)) + 'px';
      }
    }
    this.refs.accessories.style.height = height;

  }

  onClickAccessoryLink = (e) => {
    if(WINDOW){
      WINDOW.location.href = e.currentTarget.href;
    }
    e.preventDefault();
    return false;
  };

  applyFilter = () => {
    // 「すべて」カテゴリ初期表示用
    const accessoriesStartIndex = 0

    let accessories = JSON.parse(JSON.stringify(this.props.accessories));

    this.tmp.accessories = [];

    // cookieに値をセット
    if(WINDOW && DOCUMENT){
      let pathname = WINDOW.location.pathname;
      // pathname = '/';
      let date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      DOCUMENT.cookie = "mj_acbt=" + escape(this.tmp.bodyTypeName) + ";path=" + pathname + ";secure;samesite=lax";
      DOCUMENT.cookie = "mj_accg=" + escape(this.tmp.category) + ";path=" + pathname + ";secure;samesite=lax";
      DOCUMENT.cookie = "mj_acscg=" + escape(this.tmp.subCategory) + ";path=" + pathname + ";secure;samesite=lax";
      // DOCUMENT.cookie = "mj_acbt=" + escape(this.tmp.bodyTypeName) + ";path=" + pathname;
      // DOCUMENT.cookie = "mj_accg=" + escape(this.tmp.category) + ";path=" + pathname;
      // DOCUMENT.cookie = "mj_acscg=" + escape(this.tmp.subCategory) + ";path=" + pathname;
    }

    if(accessories && Array.isArray(accessories) && accessories.length > 0){
      accessories.map((accessory, index) => {
        if(this.tmp.bodyTypeName !== '' && this.tmp.bodyTypeName !== accessory.bodyTypeModel){
          return false; //skip
        }
        else if(this.tmp.category !== '' && this.tmp.category !== accessory.category){
          return false;
        }
        else if(this.tmp.subCategory !== '' && this.tmp.subCategory !== accessory.subCategory){
          return false;
        }
        this.tmp.accessories.push(accessory)
      })
    }

    // 「さらに表示する」押下回数算出用の係数
    const additionalNumber = 2
    const subtractNumber = 1
    // 「さらに表示する」初回表示枚数
    const firstCacheNumber = ACCESSORIES_COEFFICIENT * additionalNumber
    // 「さらに表示する」押下時表示用に、デフォルトデータをキャッシュしておく (再レンダーさせるために、reducer での state 更新を想定)
    // 初期表示の段階で 32 枚設定しておく (「さらに表示する」初回クリック時の state 更新が再レンダーに追いつかないため)
    this.props.updateCounterClickedTime({
      isCountable: true,
      everySixteenAccessories:
        _.filter(this.tmp.accessories, (item, index) =>
          accessoriesStartIndex <= index && index < firstCacheNumber - subtractNumber)
    })

    this.setState({
      accessories: this.tmp.accessories,
    });
  };

  closest = (node, selector) => {
    // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
    return (node.closest || function(_selector){
      do {
        // nodeとselectorがマッチしたら返す
        if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
          return node;
        }
        // マッチしなかったら親要素を代入
        node = node.parentElement || node.parentNode;
      } while (node !== null && node.nodeType === 1);
  
      return null;
    }).call(node, selector);
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true ); // event type, bubbling, cancelable
      return !element.dispatchEvent(evt);
    }
    else {
      // IE
      let evt = document.createEventObject();
      return element.fireEvent("on"+event, evt)
    }
  };
  
}

export default AccessoryList;



// WEBPACK FOOTER //
// ./src/containers/accessory-list/index.jsx